//aktuality
//=========
if (typeof $ === 'function') {

  //variables
  var w = $(window),
      html = $('html'),
      list = $('#aktuality'),
      items, newItems,
      cols = 1,
      scrollTop,
//       adjustNextItem = function (index, item) {
//         var thisItem = $(this),
//             nextItem = items.eq(index + cols),
//             margin = 0;
//         if (!nextItem.length) return;
//         margin = thisItem.offset().top + thisItem.outerHeight() - nextItem.offset().top;
//         nextItem.css('margin-top', margin + 'px');
//       },
//       adjustAgain = function () {
//         w.trigger('resize');
//         setTimeout(function () { w.trigger('resize'); }, 40);
//         setTimeout(function () { w.trigger('resize'); }, 80);
//         setTimeout(function () { w.trigger('resize'); }, 160);
//         setTimeout(function () { w.trigger('resize'); }, 320);
//       },
      loadingClass = 'btn-continue--link__loading',
      disabledClass = 'btn-continue--link__disabled',
      loadLink = $('#aktuality_load'),
      loading = $('#aktuality_loading'),
      pages = $('#aktuality_pagination a'),
      prevPage = pages.filter('[rel="prev"]'),
      currentPage = prevPage.length ? prevPage.next() : pages.first(),
      nextPage = currentPage.next(),
      load = function () {
        if (!nextPage.length) return;
        $.ajax({
          url: nextPage.attr('href'),
          beforeSend: function () {
            loadLink.addClass(loadingClass);
            loading.fadeIn();
          },
          success: function (data) {
            //process data
            data = $('<div></div>').html(data);
            newItems = data.find('.aktuality--item').hide();
            list.find('.aktuality--item__empty').remove()
            list.append(newItems.fadeIn(540));
            //adjustAgain();
            //setup pager
            prevPage.removeAttr('rel');
            nextPage.removeAttr('rel');
            prevPage = currentPage.attr('rel', 'prev');
            currentPage = nextPage;
            nextPage = currentPage.next();
            if (nextPage.length) {
              nextPage.attr('rel', 'next')
            } else {
              loadLink.addClass(disabledClass);
            }
          },
          complete: function () {
            loadLink.removeClass(loadingClass);
            loading.fadeOut();
            loadLink.blur();
          },
          error: function () {
            alert('Chyba připojení. Zkuste to prosím později.');
          }
        });
      };

  //do not initialize if no list
  if (list.length) {

    //masonry
    //---------
//     w.on('resize', function () {
//
//       //get items & columns number
//       items = list.find('.aktuality--item');
//       cols = html.is('.media-lg') || html.is('.media-xl') ? 3 : (html.is('.media-md') ? 2 : 1);
//
//       //fix window scrolling
//       scrollTop = w.scrollTop();
//
//       //reset
//       items.css('margin-top', '');
//       w.scrollTop(scrollTop);
//
//       //if there are any columns...
//       if (cols < 2) return;
//
//       //... adjust all items
//       items.each(adjustNextItem);
//       w.scrollTop(scrollTop);
//
//     });
//
//     //give the masonry layout some time to re-render
//     adjustAgain();


    //pagination
    //------------
    loadLink.on('click', function () {
      var t = $(this).blur();
      if (!t.is('.' + disabledClass)) load();
      return false;
    });


    //public API
    //------------
    if (typeof window.JRKIT === 'object') {
      window.JRKIT.aktuality = {};
      //window.JRKIT.aktuality.adjustAgain = adjustAgain;
      window.JRKIT.aktuality.load = load;
    }

    //console.log('aktuality.initalized');
    list.trigger('aktuality.initalized');

  }

}
